import { Link, LinkProps } from "@chakra-ui/react";
import { formatUrlAsDomain } from "utils/formatting";

type Props = LinkProps;

export default function ExternalDomainLink({ children, ...rest }: Props) {
  const { href } = rest;
  return (
    <Link isExternal onClick={(e) => e.stopPropagation()} {...rest}>
      {formatUrlAsDomain(href)}
      {children}
    </Link>
  );
}
